import { useEffect } from 'react';

const DEFAULT_MESSAGE =
  'Você tem alterações não salvas. Deseja sair mesmo assim?';

/**
 * Warn on tab close / refresh when `active` is true (browser native dialog).
 */
export function useUnsavedChangesGuard(
  active,
  message = DEFAULT_MESSAGE
) {
  useEffect(() => {
    if (!active) return undefined;

    const handler = (event) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active, message]);
}

export default useUnsavedChangesGuard;
